import React from "react";

export default function Footer() {
  return (
    <footer>
      <div className="footer-inner mono">
        <span>Krzysztof Zwolak, 2026</span>
        <span>Wrocław, Poland</span>
      </div>
    </footer>
  );
}
